export default "__VITE_ASSET__DdhIVvtU__"